import React from "react"

const ShayanJavadi = () => {
    return (
        <div
            style={{
                width: 55,
                height: 55,
                borderRadius: "100%",
                backgroundColor: "#d1d5db",
            }}
        />
    )
}

export default ShayanJavadi
